import React, { Component } from 'react';
import Connector from '../../data/Connector';
import Moment from 'moment';
import 'moment/locale/es';
import Navigation from '../../components/Navigation';
import Header from '../../components/Headers/form';
import * as ROUTES from '../../constants/routes';
import { withRouter } from 'react-router-dom';
import HelperPage from '../../helper/Page';
import EventEmitter from '../../helper/Emitter';
import { withTranslation } from "react-i18next";
import lang from 'i18next';
import { AuthUserContext, withAuthorization } from '../../components/Session';


class EmailUsagePage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      months: global.spaceEmailUsage,
    };
  }


  componentDidMount() {
    HelperPage.initializeForm('Email Usage - PT Mate')
    this._isMounted = true

    EventEmitter.subscribe('userLoaded', (event) => this.configureData())
    EventEmitter.subscribe('emailUsageLoaded', (event) => this.configureData())
    Connector.loadEmailUsage()
    this.configureData()
  }


  componentWillUnmount() {
    this._isMounted = false
    EventEmitter.unsubscribe('userLoaded', () => {})
    EventEmitter.unsubscribe('emailUsageLoaded', () => {})
  }


  configureData() {
    if(this._isMounted) {
      this.setState({
        months: global.spaceEmailUsage
      })
    }
  }


  getEmailsCurrent() {
    var label = 0
    if(global.spaceEmailUsage[Moment().format('MM-YYYY')] !== undefined) {
      label = global.spaceEmailUsage[Moment().format('MM-YYYY')]
    }
    return label
  }


  getCost(item) {
    var label = 0
    var num = 0
    if(global.spaceEmailUsage[item] !== undefined) {
      num = global.spaceEmailUsage[item]
    }
    var calc = num/1000
    label = Math.ceil(calc)*5
    return label.toFixed(2)
  }


  getTier() {
    var label = 0
    var num = 0
    if(global.spaceEmailUsage[Moment().format('MM-YYYY')] !== undefined) {
      num = global.spaceEmailUsage[Moment().format('MM-YYYY')]
    }
    var calc = num/1000
    label = Math.ceil(calc)
    return label
  }



  // Display stuff ------------------------------------------------------------



  renderList() {
    var list = Object.keys(global.spaceEmailUsage)
    if(list.length > 0) {
      list.sort((a,b) => Moment(b, 'MM-YYYY') - Moment(a, 'MM-YYYY'));
      return (
        <div>
          {list.map(item => (
            <div className="box list simple highlight mb-10" key={item}>
              <div className="col-4">
                <p>{Moment(item, 'MM-YYYY').locale(lang.language).format('MMMM YYYY')}</p>
              </div>
              <div className="col-4">
                <p>{global.spaceEmailUsage[item]}</p>
              </div>
              <div className="col-4">
                <p>{global.curSym}{this.getCost(item)}</p>
              </div>
            </div>
          ))}
        </div>
      )
    }
  }


  renderBase() {
    return (
      <div className={'theme-'+global.spaceTheme}>
        <div className="content">
          <div className="infobox large primary mb-30">
            <p>{lang.t('account:email.text1')}</p>
          </div>
          <div className="col-9">
            <h3 className="mb-20">{lang.t('account:email.thismonth')}</h3>
            <div className='info large col-3 clear'>
              <label>{lang.t('account:email.totalsent')}</label>
              <p>{this.getEmailsCurrent()}</p>
              <span>{lang.t('account:email.of')} {this.getTier()*1000} {lang.t('account:email.intier')} {this.getTier()}</span>
            </div>
            <div className='info large col-3'>
              <label>{lang.t('account:email.cost')}</label>
              <p>{this.getEmailsCurrent()}</p>
              <span>{lang.t('account:email.tier')} {this.getTier()}</span>
            </div>
            <div className="clear"></div>
          </div>
          <div className="col-3">
            <h3 className="mb-20">{lang.t('account:email.costinfo')}</h3>
            <p>{lang.t('account:email.text2')} {global.curSym}5 {lang.t('account:email.text3')}</p>
          </div>
          <div className="listheader clear">
            <h3>{lang.t('account:email.pastusage')}</h3>
            <div className="clear"></div>
          </div>
          {this.renderList()}
          <div className="sv-30"></div>
        </div>
        <Header title={lang.t('account:email.title')} link={ROUTES.ADMINEMAILS}/>
        <Navigation active='' />
      </div>
    )
  }


  render() {
    return (
      <AuthUserContext.Consumer>
        {authUser => (
          this.renderBase()
        )}
      </AuthUserContext.Consumer>
    )
  }
}



const condition = authUser => !!authUser;
export default withTranslation(['account','common'])(withRouter(withAuthorization(condition)(EmailUsagePage)));